import { RootState } from '../../modules'
import { useReduxSelector } from '../use-redux-selector'

export const useEmbed = () => useReduxSelector((state: RootState) => state.embed)
